import { TableColumn } from "../../types/table-column";

export const AIInventoryColumns: TableColumn[] = [
  // {
  //   type: "checkbox",
  //   fieldName: "checkbox",
  //   value: "id",
  //   width: 2,
  // },
  {
    type: "string",
    fieldName: "AI_SCENARIO",
    value: "title",
    secondaryValue: "internalId",
    width: 20,
  },
  {
    type: "arrayIcons",
    fieldName: "USED_IN",
    value: "operations",
    width: 13,
  },
  {
    type: "arrayIcons",
    fieldName: "APPLICATION_AREAS",
    value: "areas",
    width: 15,
  },
  {
    type: "release",
    fieldName: "RELEASE",
    value: "release",
    width: 5,
  },
  {
    type: "object",
    fieldName: "RISK",
    value: "riskLevel",
    width: 15,
  },
  {
    type: "questions_status",
    fieldName: "PROGRESS",
    value: "answeredQuestions",
    width: 8,
  },
  {
    type: "string",
    fieldName: "CONTACT",
    value: "keyContact",
    width: 12,
  },
  {
    type: "date",
    fieldName: "LAST_MODIFIED",
    value: "updatedAt",
    width: "fit-content",
  },
];
